export default {
  props: { justword: Boolean },
  methods: {
    displayVersion() {
      //FG - FOOF - After Cert - First Release (5) - flipped the order of parms msg and ttl
      var optionsToUse = {
        title: "About Hydroware",
        message: "Version: " + this.$hydrowareCommonJS.Version 
      }
      this.$hydrowareCommonJS.displayPopupMessage(this, optionsToUse)

      /* CODE BELOW IS BEFORE FIRST RELEASE (5)
      const h = this.$createElement;
      var message = h('div', [
        h('div', "Version: " + this.$hydrowareCommonJS.Version),
      ])
      this.$hydrowareCommonJS.displayPopupMessage(
        this, 
        "About Hydroware", //TITLE
        message
      );
      */
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/VersionSystem/VersionSystem.controller.js